import React from 'react';
import { TabsContent } from '../ui/tabs';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';
import { TrendingUp } from 'lucide-react';
import { FinancialCalculator } from './FinancialCalculator';

export function CalculatorTab({ project, transactions, jvAgreements }) {
  return (
    <TabsContent value="calculator">
      <Card className="rounded-sm border">
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-semibold uppercase tracking-wide flex items-center gap-2">
            <TrendingUp className="w-4 h-4" />
            Financial Calculator (What-If Scenarios)
          </CardTitle>
        </CardHeader>
        <CardContent>
          <FinancialCalculator 
            project={project} 
            transactions={transactions}
            jvAgreements={jvAgreements}
          />
        </CardContent>
      </Card>
    </TabsContent>
  );
}
